/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessToken,
  BulkResult,
  BulkUpdateStatus,
  Courier,
  CourierPackage,
  CourierRegenerateMarketingInfoRequest,
  CourierSettings,
  CourierUser,
  DeliveryRequest,
  Invoice,
  InvoiceBulkRegenerateInvoicesForCourierRequest,
  InvoiceBulkStatusChangeRequest,
  InvoiceCheckoutRequest,
  InvoiceGenerateInvoiceForDeliveryRequestRequest,
  InvoiceGenerateInvoiceRequest,
  InvoiceGeneratePDFBuffer200Response,
  InvoiceGeneratePDFBufferRequest,
  InvoiceGeneratePackageInvoiceRequest,
  InvoiceGetCustomerBalanceRequest,
  InvoiceInvoiceIdRequest,
  InvoiceInvoiceViewRenderRequest,
  NewCourierPackage,
  NewCourierUser,
  NewInvoice,
  NewRole,
  NewRoleMapping,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  Town,
} from '../models/index';
import {
    AccessTokenFromJSON,
    AccessTokenToJSON,
    BulkResultFromJSON,
    BulkResultToJSON,
    BulkUpdateStatusFromJSON,
    BulkUpdateStatusToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierPackageFromJSON,
    CourierPackageToJSON,
    CourierRegenerateMarketingInfoRequestFromJSON,
    CourierRegenerateMarketingInfoRequestToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    DeliveryRequestFromJSON,
    DeliveryRequestToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    InvoiceBulkRegenerateInvoicesForCourierRequestFromJSON,
    InvoiceBulkRegenerateInvoicesForCourierRequestToJSON,
    InvoiceBulkStatusChangeRequestFromJSON,
    InvoiceBulkStatusChangeRequestToJSON,
    InvoiceCheckoutRequestFromJSON,
    InvoiceCheckoutRequestToJSON,
    InvoiceGenerateInvoiceForDeliveryRequestRequestFromJSON,
    InvoiceGenerateInvoiceForDeliveryRequestRequestToJSON,
    InvoiceGenerateInvoiceRequestFromJSON,
    InvoiceGenerateInvoiceRequestToJSON,
    InvoiceGeneratePDFBuffer200ResponseFromJSON,
    InvoiceGeneratePDFBuffer200ResponseToJSON,
    InvoiceGeneratePDFBufferRequestFromJSON,
    InvoiceGeneratePDFBufferRequestToJSON,
    InvoiceGeneratePackageInvoiceRequestFromJSON,
    InvoiceGeneratePackageInvoiceRequestToJSON,
    InvoiceGetCustomerBalanceRequestFromJSON,
    InvoiceGetCustomerBalanceRequestToJSON,
    InvoiceInvoiceIdRequestFromJSON,
    InvoiceInvoiceIdRequestToJSON,
    InvoiceInvoiceViewRenderRequestFromJSON,
    InvoiceInvoiceViewRenderRequestToJSON,
    NewCourierPackageFromJSON,
    NewCourierPackageToJSON,
    NewCourierUserFromJSON,
    NewCourierUserToJSON,
    NewInvoiceFromJSON,
    NewInvoiceToJSON,
    NewRoleFromJSON,
    NewRoleToJSON,
    NewRoleMappingFromJSON,
    NewRoleMappingToJSON,
    RoleFromJSON,
    RoleToJSON,
    RoleMappingFromJSON,
    RoleMappingToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    TownFromJSON,
    TownToJSON,
} from '../models/index';

export interface InvoiceBulkDeleteRequest {
    invoiceIds: Array<number>;
}

export interface InvoiceBulkRegenerateInvoicesRequest {
    invoiceIds: Array<number>;
}

export interface InvoiceBulkRegenerateInvoicesForCourierOperationRequest {
    invoiceBulkRegenerateInvoicesForCourierRequest?: InvoiceBulkRegenerateInvoicesForCourierRequest;
}

export interface InvoiceBulkStatusChangeOperationRequest {
    invoiceIds?: InvoiceBulkStatusChangeRequest;
}

export interface InvoiceBulkUpdateStatusV2Request {
    bulkUpdateStatus: BulkUpdateStatus;
}

export interface InvoiceCheckoutOperationRequest {
    invoiceCheckoutRequest: InvoiceCheckoutRequest;
}

export interface InvoiceCountRequest {
    where?: string;
}

export interface InvoiceCreateRequest {
    data?: NewInvoice;
}

export interface InvoiceCreateChangeStreamGetInvoicesChangeStreamRequest {
    options?: string;
}

export interface InvoiceCreateChangeStreamPostInvoicesChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface InvoiceCreatePaypalOrderRequest {
    invoiceIds?: Array<number>;
}

export interface InvoiceDeleteByIdRequest {
    id: string;
}

export interface InvoiceExecutePaypalOrderRequest {
    paymentID?: string;
}

export interface InvoiceExistsGetInvoicesidExistsRequest {
    id: string;
}

export interface InvoiceExistsHeadInvoicesidRequest {
    id: string;
}

export interface InvoiceExportInvoicesForQuickBooksRequest {
    businessId: string;
    startDate: Date;
    endDate: Date;
}

export interface InvoiceFindRequest {
    filter?: string;
}

export interface InvoiceFindByIdRequest {
    id: string;
    filter?: string;
}

export interface InvoiceFindOneRequest {
    filter?: string;
}

export interface InvoiceGenerateInvoiceOperationRequest {
    invoiceGenerateInvoiceRequest?: InvoiceGenerateInvoiceRequest;
}

export interface InvoiceGenerateInvoiceForDeliveryRequestOperationRequest {
    invoiceGenerateInvoiceForDeliveryRequestRequest: InvoiceGenerateInvoiceForDeliveryRequestRequest;
}

export interface InvoiceGeneratePDFBufferOperationRequest {
    invoiceGeneratePDFBufferRequest: InvoiceGeneratePDFBufferRequest;
}

export interface InvoiceGeneratePackageInvoiceOperationRequest {
    invoiceGeneratePackageInvoiceRequest: InvoiceGeneratePackageInvoiceRequest;
}

export interface InvoiceGetCustomerBalanceOperationRequest {
    invoiceGetCustomerBalanceRequest?: InvoiceGetCustomerBalanceRequest;
}

export interface InvoiceInvoiceIdOperationRequest {
    invoiceInvoiceIdRequest: InvoiceInvoiceIdRequest;
}

export interface InvoiceInvoiceViewRenderOperationRequest {
    invoiceInvoiceViewRenderRequest: InvoiceInvoiceViewRenderRequest;
}

export interface InvoiceMarkAsPaidRequest {
    invoiceIds?: Array<number>;
}

export interface InvoicePatchOrCreateRequest {
    data?: Invoice;
}

export interface InvoicePreviewRequest {
    courierId: number;
    invoiceId: string;
}

export interface InvoicePreviewMultiPackageRequest {
    packageIds: number[];
    courierId: string;
}

export interface InvoiceCreateMultiPackageRequest {
    packageIds: number[];
    courierId: string;
    userId: string;
    items?: Array<{ name: string; description?: string; quantity: number; price: number; packageInfo?: string }>;
    discount?: number;
}

export interface InvoiceGetEligiblePackagesRequest {
    courierId: string;
    customerId?: number;
}

export interface InvoicePrototypeCountCustomerAccessTokensRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCountCustomerCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCountCustomerInvoicesRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCountCustomerReferrerRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCountCustomerRoleMappingsRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCountCustomerRolesRequest {
    id: string;
    where?: string;
}

export interface InvoicePrototypeCreateBusinessCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface InvoicePrototypeCreateCourierPackageInvoiceRequest {
    id: string;
    data?: Invoice;
}

export interface InvoicePrototypeCreateCustomerAccessTokensRequest {
    id: string;
    data?: AccessToken;
}

export interface InvoicePrototypeCreateCustomerCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface InvoicePrototypeCreateCustomerInvoicesRequest {
    id: string;
    data?: NewInvoice;
}

export interface InvoicePrototypeCreateCustomerReferrerRequest {
    id: string;
    data?: NewCourierUser;
}

export interface InvoicePrototypeCreateCustomerRoleMappingsRequest {
    id: string;
    data?: NewRoleMapping;
}

export interface InvoicePrototypeCreateCustomerRolesRequest {
    id: string;
    data?: NewRole;
}

export interface InvoicePrototypeDeleteCustomerAccessTokensRequest {
    id: string;
}

export interface InvoicePrototypeDeleteCustomerCourierPackagesRequest {
    id: string;
}

export interface InvoicePrototypeDeleteCustomerInvoicesRequest {
    id: string;
}

export interface InvoicePrototypeDeleteCustomerReferrerRequest {
    id: string;
}

export interface InvoicePrototypeDeleteCustomerRoleMappingsRequest {
    id: string;
}

export interface InvoicePrototypeDeleteCustomerRolesRequest {
    id: string;
}

export interface InvoicePrototypeDestroyBusinessCourierSettingRequest {
    id: string;
}

export interface InvoicePrototypeDestroyByIdCustomerAccessTokensRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyByIdCustomerCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyByIdCustomerInvoicesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyByIdCustomerReferrerRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyByIdCustomerRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyByIdCustomerRolesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeDestroyCourierPackageInvoiceRequest {
    id: string;
}

export interface InvoicePrototypeExistsCustomerRolesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerAccessTokensRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerInvoicesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerReferrerRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeFindByIdCustomerRolesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeGetBusinessRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetBusinessCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCourierPackageRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCourierPackageCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCourierPackageInvoiceRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCourierPackageOwnerRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCustomerRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetCustomerAccessTokensRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetCustomerCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetCustomerInvoicesRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetCustomerReferrerRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetCustomerRoleMappingsRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetCustomerRolesRequest {
    id: string;
    filter?: string;
}

export interface InvoicePrototypeGetDeliveryRequestRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetDeliveryRequestCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetDeliveryRequestCourierUserRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeGetDeliveryRequestDeliveryLocationRequest {
    id: string;
    refresh?: boolean;
}

export interface InvoicePrototypeLinkCustomerRolesRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface InvoicePrototypePatchAttributesRequest {
    id: string;
    data?: Invoice;
}

export interface InvoicePrototypeUnlinkCustomerRolesRequest {
    id: string;
    fk: string;
}

export interface InvoicePrototypeUpdateBusinessCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface InvoicePrototypeUpdateByIdCustomerAccessTokensRequest {
    id: string;
    fk: string;
    data?: AccessToken;
}

export interface InvoicePrototypeUpdateByIdCustomerCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface InvoicePrototypeUpdateByIdCustomerInvoicesRequest {
    id: string;
    fk: string;
    data?: Invoice;
}

export interface InvoicePrototypeUpdateByIdCustomerReferrerRequest {
    id: string;
    fk: string;
    data?: CourierUser;
}

export interface InvoicePrototypeUpdateByIdCustomerRoleMappingsRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface InvoicePrototypeUpdateByIdCustomerRolesRequest {
    id: string;
    fk: string;
    data?: Role;
}

export interface InvoicePrototypeUpdateCourierPackageInvoiceRequest {
    id: string;
    data?: Invoice;
}

export interface InvoiceRegenerateAllInvoicesForCourierRequest {
    courierRegenerateMarketingInfoRequest: CourierRegenerateMarketingInfoRequest;
}

export interface InvoiceReplaceByIdPostInvoicesidReplaceRequest {
    id: string;
    data?: Invoice;
}

export interface InvoiceReplaceByIdPutInvoicesidRequest {
    id: string;
    data?: Invoice;
}

export interface InvoiceReplaceOrCreatePostInvoicesReplaceOrCreateRequest {
    data?: Invoice;
}

export interface InvoiceReplaceOrCreatePutInvoicesRequest {
    data?: Invoice;
}

export interface InvoiceUpdateAllRequest {
    where?: string;
    data?: Invoice;
}

export interface InvoiceUpsertWithWhereRequest {
    where?: string;
    data?: Invoice;
}

export interface InvoiceSearchCustomersRequest {
    courierId: string;
    searchTerm?: string;
    limit?: number;
}

export interface InvoiceSearchCustomersResult {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    mailboxNumber: number | null;
}

export interface InvoiceSearchPackagesForInvoiceRequest {
    courierId: string;
    customerId?: number;
    searchTerm?: string;
    limit?: number;
}

export interface InvoiceSearchPackagesResult {
    id: number;
    trackingNo: string;
    description: string;
    weight: number;
    status: string;
    manifestNumber: string;
    ownerId: number;
}

export interface InvoiceCreateCustomInvoiceItem {
    name: string;
    description?: string;
    quantity: number;
    price: number;
}

export interface InvoiceCreateCustomInvoiceRequest {
    businessId: number;
    items: Array<InvoiceCreateCustomInvoiceItem>;
    /** Either customerId or recipientName is required. */
    customerId?: number;
    docType?: string;
    recipientName?: string;
    recipientEmail?: string;
    recipientPhone?: string;
    notes?: string;
    terms?: string;
    taxRate?: number;
    discount?: number;
    dateDue?: string;
    referenceNumber?: string;
    courierPackageId?: number;
    cashierId?: number;
}

export interface InvoiceConvertQuoteRequest {
    invoiceId: number;
}

/**
 *
 */
export class InvoiceApi extends runtime.BaseAPI {

    /**
     */
    async invoiceBulkDeleteRaw(requestParameters: InvoiceBulkDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['invoiceIds'] == null) {
            throw new runtime.RequiredError(
                'invoiceIds',
                'Required parameter "invoiceIds" was null or undefined when calling invoiceBulkDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/bulkDelete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['invoiceIds'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceBulkDelete(requestParameters: InvoiceBulkDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceBulkDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceBulkRegenerateInvoicesRaw(requestParameters: InvoiceBulkRegenerateInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['invoiceIds'] == null) {
            throw new runtime.RequiredError(
                'invoiceIds',
                'Required parameter "invoiceIds" was null or undefined when calling invoiceBulkRegenerateInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/bulkRegenerateInvoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['invoiceIds'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceBulkRegenerateInvoices(requestParameters: InvoiceBulkRegenerateInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceBulkRegenerateInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceBulkRegenerateInvoicesForCourierRaw(requestParameters: InvoiceBulkRegenerateInvoicesForCourierOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/bulkRegenerateInvoicesForCourier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceBulkRegenerateInvoicesForCourierRequestToJSON(requestParameters['invoiceBulkRegenerateInvoicesForCourierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceBulkRegenerateInvoicesForCourier(requestParameters: InvoiceBulkRegenerateInvoicesForCourierOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceBulkRegenerateInvoicesForCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceBulkStatusChangeRaw(requestParameters: InvoiceBulkStatusChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/bulkStatusChange`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceBulkStatusChangeRequestToJSON(requestParameters['invoiceIds']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceBulkStatusChange(requestParameters: InvoiceBulkStatusChangeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceBulkStatusChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceBulkUpdateStatusV2Raw(requestParameters: InvoiceBulkUpdateStatusV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkResult>> {
        if (requestParameters['bulkUpdateStatus'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateStatus',
                'Required parameter "bulkUpdateStatus" was null or undefined when calling invoiceBulkUpdateStatusV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/bulkUpdateStatusV2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateStatusToJSON(requestParameters['bulkUpdateStatus']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkResultFromJSON(jsonValue));
    }

    /**
     */
    async invoiceBulkUpdateStatusV2(requestParameters: InvoiceBulkUpdateStatusV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkResult> {
        const response = await this.invoiceBulkUpdateStatusV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceCheckoutRaw(requestParameters: InvoiceCheckoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['invoiceCheckoutRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceCheckoutRequest',
                'Required parameter "invoiceCheckoutRequest" was null or undefined when calling invoiceCheckout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/checkout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                checkoutData: InvoiceCheckoutRequestToJSON(requestParameters['invoiceCheckoutRequest'])
            },
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceCheckout(requestParameters: InvoiceCheckoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceCheckoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async invoiceCountRaw(requestParameters: InvoiceCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async invoiceCount(requestParameters: InvoiceCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoiceCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async invoiceCreateRaw(requestParameters: InvoiceCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async invoiceCreate(requestParameters: InvoiceCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async invoiceCreateChangeStreamGetInvoicesChangeStreamRaw(requestParameters: InvoiceCreateChangeStreamGetInvoicesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async invoiceCreateChangeStreamGetInvoicesChangeStream(requestParameters: InvoiceCreateChangeStreamGetInvoicesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.invoiceCreateChangeStreamGetInvoicesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async invoiceCreateChangeStreamPostInvoicesChangeStreamRaw(requestParameters: InvoiceCreateChangeStreamPostInvoicesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async invoiceCreateChangeStreamPostInvoicesChangeStream(requestParameters: InvoiceCreateChangeStreamPostInvoicesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.invoiceCreateChangeStreamPostInvoicesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceCreatePaypalOrderRaw(requestParameters: InvoiceCreatePaypalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/createPaypalOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['invoiceIds'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceCreatePaypalOrder(requestParameters: InvoiceCreatePaypalOrderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceCreatePaypalOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async invoiceDeleteByIdRaw(requestParameters: InvoiceDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async invoiceDeleteById(requestParameters: InvoiceDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceExecutePaypalOrderRaw(requestParameters: InvoiceExecutePaypalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/executePaypalOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['paymentID'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceExecutePaypalOrder(requestParameters: InvoiceExecutePaypalOrderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceExecutePaypalOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async invoiceExistsGetInvoicesidExistsRaw(requestParameters: InvoiceExistsGetInvoicesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceExistsGetInvoicesidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async invoiceExistsGetInvoicesidExists(requestParameters: InvoiceExistsGetInvoicesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.invoiceExistsGetInvoicesidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async invoiceExistsHeadInvoicesidRaw(requestParameters: InvoiceExistsHeadInvoicesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceExistsHeadInvoicesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async invoiceExistsHeadInvoicesid(requestParameters: InvoiceExistsHeadInvoicesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.invoiceExistsHeadInvoicesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceExportInvoicesForQuickBooksRaw(requestParameters: InvoiceExportInvoicesForQuickBooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['businessId'] == null) {
            throw new runtime.RequiredError(
                'businessId',
                'Required parameter "businessId" was null or undefined when calling invoiceExportInvoicesForQuickBooks().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling invoiceExportInvoicesForQuickBooks().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling invoiceExportInvoicesForQuickBooks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/export-invoices-quickbooks/{businessId}/{startDate}/{endDate}`.replace(`{${"businessId"}}`, encodeURIComponent(String(requestParameters['businessId']))).replace(`{${"startDate"}}`, encodeURIComponent(String(requestParameters['startDate']))).replace(`{${"endDate"}}`, encodeURIComponent(String(requestParameters['endDate']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invoiceExportInvoicesForQuickBooks(requestParameters: InvoiceExportInvoicesForQuickBooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoiceExportInvoicesForQuickBooksRaw(requestParameters, initOverrides);
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async invoiceFindRaw(requestParameters: InvoiceFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async invoiceFind(requestParameters: InvoiceFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.invoiceFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async invoiceFindByIdRaw(requestParameters: InvoiceFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async invoiceFindById(requestParameters: InvoiceFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async invoiceFindOneRaw(requestParameters: InvoiceFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async invoiceFindOne(requestParameters: InvoiceFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceGenerateInvoiceRaw(requestParameters: InvoiceGenerateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/generateInvoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceGenerateInvoiceRequestToJSON(requestParameters['invoiceGenerateInvoiceRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async invoiceGenerateInvoice(requestParameters: InvoiceGenerateInvoiceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.invoiceGenerateInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate invoice for delivery request
     */
    async invoiceGenerateInvoiceForDeliveryRequestRaw(requestParameters: InvoiceGenerateInvoiceForDeliveryRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['invoiceGenerateInvoiceForDeliveryRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceGenerateInvoiceForDeliveryRequestRequest',
                'Required parameter "invoiceGenerateInvoiceForDeliveryRequestRequest" was null or undefined when calling invoiceGenerateInvoiceForDeliveryRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/generateInvoiceForDeliveryRequest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceGenerateInvoiceForDeliveryRequestRequestToJSON(requestParameters['invoiceGenerateInvoiceForDeliveryRequestRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate invoice for delivery request
     */
    async invoiceGenerateInvoiceForDeliveryRequest(requestParameters: InvoiceGenerateInvoiceForDeliveryRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.invoiceGenerateInvoiceForDeliveryRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceGeneratePDFBufferRaw(requestParameters: InvoiceGeneratePDFBufferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceGeneratePDFBuffer200Response>> {
        if (requestParameters['invoiceGeneratePDFBufferRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceGeneratePDFBufferRequest',
                'Required parameter "invoiceGeneratePDFBufferRequest" was null or undefined when calling invoiceGeneratePDFBuffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/generatePDFBuffer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceGeneratePDFBufferRequestToJSON(requestParameters['invoiceGeneratePDFBufferRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceGeneratePDFBuffer200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async invoiceGeneratePDFBuffer(requestParameters: InvoiceGeneratePDFBufferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceGeneratePDFBuffer200Response> {
        const response = await this.invoiceGeneratePDFBufferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceGeneratePackageInvoiceRaw(requestParameters: InvoiceGeneratePackageInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['invoiceGeneratePackageInvoiceRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceGeneratePackageInvoiceRequest',
                'Required parameter "invoiceGeneratePackageInvoiceRequest" was null or undefined when calling invoiceGeneratePackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/generatePackageInvoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceGeneratePackageInvoiceRequestToJSON(requestParameters['invoiceGeneratePackageInvoiceRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async invoiceGeneratePackageInvoice(requestParameters: InvoiceGeneratePackageInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.invoiceGeneratePackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceGetCustomerBalanceRaw(requestParameters: InvoiceGetCustomerBalanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/getCustomerBalance`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceGetCustomerBalanceRequestToJSON(requestParameters['invoiceGetCustomerBalanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceGetCustomerBalance(requestParameters: InvoiceGetCustomerBalanceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceGetCustomerBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Invoice
     */
    async invoiceInvoiceIdRaw(requestParameters: InvoiceInvoiceIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['invoiceInvoiceIdRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceInvoiceIdRequest',
                'Required parameter "invoiceInvoiceIdRequest" was null or undefined when calling invoiceInvoiceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/invoiceId`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceInvoiceIdRequestToJSON(requestParameters['invoiceInvoiceIdRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate Invoice
     */
    async invoiceInvoiceId(requestParameters: InvoiceInvoiceIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.invoiceInvoiceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceInvoiceViewRenderRaw(requestParameters: InvoiceInvoiceViewRenderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['invoiceInvoiceViewRenderRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceInvoiceViewRenderRequest',
                'Required parameter "invoiceInvoiceViewRenderRequest" was null or undefined when calling invoiceInvoiceViewRender().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/invoiceViewRender`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceInvoiceViewRenderRequestToJSON(requestParameters['invoiceInvoiceViewRenderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceInvoiceViewRender(requestParameters: InvoiceInvoiceViewRenderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceInvoiceViewRenderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceMarkAsPaidRaw(requestParameters: InvoiceMarkAsPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/markAsPaid`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['invoiceIds'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async invoiceMarkAsPaid(requestParameters: InvoiceMarkAsPaidRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.invoiceMarkAsPaidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async invoicePatchOrCreateRaw(requestParameters: InvoicePatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async invoicePatchOrCreate(requestParameters: InvoicePatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a preview of an invoice
     */
    async invoicePreviewRaw(requestParameters: InvoicePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoicePreview().'
            );
        }

        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling invoicePreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoiceId'] = requestParameters['invoiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get a preview of an invoice
     */
    async invoicePreview(requestParameters: InvoicePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePreviewRaw(requestParameters, initOverrides);
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async invoicePrototypeCountCustomerAccessTokensRaw(requestParameters: InvoicePrototypeCountCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async invoicePrototypeCountCustomerAccessTokens(requestParameters: InvoicePrototypeCountCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async invoicePrototypeCountCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeCountCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async invoicePrototypeCountCustomerCourierPackages(requestParameters: InvoicePrototypeCountCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts invoices of CourierUser.
     */
    async invoicePrototypeCountCustomerInvoicesRaw(requestParameters: InvoicePrototypeCountCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts invoices of CourierUser.
     */
    async invoicePrototypeCountCustomerInvoices(requestParameters: InvoicePrototypeCountCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts referrer of CourierUser.
     */
    async invoicePrototypeCountCustomerReferrerRaw(requestParameters: InvoicePrototypeCountCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts referrer of CourierUser.
     */
    async invoicePrototypeCountCustomerReferrer(requestParameters: InvoicePrototypeCountCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async invoicePrototypeCountCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeCountCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async invoicePrototypeCountCustomerRoleMappings(requestParameters: InvoicePrototypeCountCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roles of CourierUser.
     */
    async invoicePrototypeCountCustomerRolesRaw(requestParameters: InvoicePrototypeCountCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCountCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roles of CourierUser.
     */
    async invoicePrototypeCountCustomerRoles(requestParameters: InvoicePrototypeCountCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.invoicePrototypeCountCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async invoicePrototypeCreateBusinessCourierSettingRaw(requestParameters: InvoicePrototypeCreateBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateBusinessCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/business/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async invoicePrototypeCreateBusinessCourierSetting(requestParameters: InvoicePrototypeCreateBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.invoicePrototypeCreateBusinessCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async invoicePrototypeCreateCourierPackageInvoiceRaw(requestParameters: InvoicePrototypeCreateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async invoicePrototypeCreateCourierPackageInvoice(requestParameters: InvoicePrototypeCreateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeCreateCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async invoicePrototypeCreateCustomerAccessTokensRaw(requestParameters: InvoicePrototypeCreateCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async invoicePrototypeCreateCustomerAccessTokens(requestParameters: InvoicePrototypeCreateCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.invoicePrototypeCreateCustomerAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async invoicePrototypeCreateCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeCreateCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async invoicePrototypeCreateCustomerCourierPackages(requestParameters: InvoicePrototypeCreateCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.invoicePrototypeCreateCustomerCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async invoicePrototypeCreateCustomerInvoicesRaw(requestParameters: InvoicePrototypeCreateCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async invoicePrototypeCreateCustomerInvoices(requestParameters: InvoicePrototypeCreateCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeCreateCustomerInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async invoicePrototypeCreateCustomerReferrerRaw(requestParameters: InvoicePrototypeCreateCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async invoicePrototypeCreateCustomerReferrer(requestParameters: InvoicePrototypeCreateCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeCreateCustomerReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async invoicePrototypeCreateCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeCreateCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async invoicePrototypeCreateCustomerRoleMappings(requestParameters: InvoicePrototypeCreateCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.invoicePrototypeCreateCustomerRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async invoicePrototypeCreateCustomerRolesRaw(requestParameters: InvoicePrototypeCreateCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeCreateCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async invoicePrototypeCreateCustomerRoles(requestParameters: InvoicePrototypeCreateCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.invoicePrototypeCreateCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async invoicePrototypeDeleteCustomerAccessTokensRaw(requestParameters: InvoicePrototypeDeleteCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async invoicePrototypeDeleteCustomerAccessTokens(requestParameters: InvoicePrototypeDeleteCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async invoicePrototypeDeleteCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeDeleteCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async invoicePrototypeDeleteCustomerCourierPackages(requestParameters: InvoicePrototypeDeleteCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all invoices of this model.
     */
    async invoicePrototypeDeleteCustomerInvoicesRaw(requestParameters: InvoicePrototypeDeleteCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all invoices of this model.
     */
    async invoicePrototypeDeleteCustomerInvoices(requestParameters: InvoicePrototypeDeleteCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all referrer of this model.
     */
    async invoicePrototypeDeleteCustomerReferrerRaw(requestParameters: InvoicePrototypeDeleteCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all referrer of this model.
     */
    async invoicePrototypeDeleteCustomerReferrer(requestParameters: InvoicePrototypeDeleteCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async invoicePrototypeDeleteCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeDeleteCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async invoicePrototypeDeleteCustomerRoleMappings(requestParameters: InvoicePrototypeDeleteCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roles of this model.
     */
    async invoicePrototypeDeleteCustomerRolesRaw(requestParameters: InvoicePrototypeDeleteCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDeleteCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roles of this model.
     */
    async invoicePrototypeDeleteCustomerRoles(requestParameters: InvoicePrototypeDeleteCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDeleteCustomerRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async invoicePrototypeDestroyBusinessCourierSettingRaw(requestParameters: InvoicePrototypeDestroyBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyBusinessCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/business/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async invoicePrototypeDestroyBusinessCourierSetting(requestParameters: InvoicePrototypeDestroyBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyBusinessCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async invoicePrototypeDestroyByIdCustomerAccessTokensRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async invoicePrototypeDestroyByIdCustomerAccessTokens(requestParameters: InvoicePrototypeDestroyByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async invoicePrototypeDestroyByIdCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async invoicePrototypeDestroyByIdCustomerCourierPackages(requestParameters: InvoicePrototypeDestroyByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async invoicePrototypeDestroyByIdCustomerInvoicesRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async invoicePrototypeDestroyByIdCustomerInvoices(requestParameters: InvoicePrototypeDestroyByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async invoicePrototypeDestroyByIdCustomerReferrerRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async invoicePrototypeDestroyByIdCustomerReferrer(requestParameters: InvoicePrototypeDestroyByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async invoicePrototypeDestroyByIdCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async invoicePrototypeDestroyByIdCustomerRoleMappings(requestParameters: InvoicePrototypeDestroyByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roles.
     */
    async invoicePrototypeDestroyByIdCustomerRolesRaw(requestParameters: InvoicePrototypeDestroyByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyByIdCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeDestroyByIdCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roles.
     */
    async invoicePrototypeDestroyByIdCustomerRoles(requestParameters: InvoicePrototypeDestroyByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyByIdCustomerRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes invoice of this model.
     */
    async invoicePrototypeDestroyCourierPackageInvoiceRaw(requestParameters: InvoicePrototypeDestroyCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeDestroyCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes invoice of this model.
     */
    async invoicePrototypeDestroyCourierPackageInvoice(requestParameters: InvoicePrototypeDestroyCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeDestroyCourierPackageInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async invoicePrototypeExistsCustomerRolesRaw(requestParameters: InvoicePrototypeExistsCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeExistsCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeExistsCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async invoicePrototypeExistsCustomerRoles(requestParameters: InvoicePrototypeExistsCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.invoicePrototypeExistsCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async invoicePrototypeFindByIdCustomerAccessTokensRaw(requestParameters: InvoicePrototypeFindByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async invoicePrototypeFindByIdCustomerAccessTokens(requestParameters: InvoicePrototypeFindByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.invoicePrototypeFindByIdCustomerAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async invoicePrototypeFindByIdCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeFindByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async invoicePrototypeFindByIdCustomerCourierPackages(requestParameters: InvoicePrototypeFindByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.invoicePrototypeFindByIdCustomerCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for invoices.
     */
    async invoicePrototypeFindByIdCustomerInvoicesRaw(requestParameters: InvoicePrototypeFindByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for invoices.
     */
    async invoicePrototypeFindByIdCustomerInvoices(requestParameters: InvoicePrototypeFindByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeFindByIdCustomerInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for referrer.
     */
    async invoicePrototypeFindByIdCustomerReferrerRaw(requestParameters: InvoicePrototypeFindByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for referrer.
     */
    async invoicePrototypeFindByIdCustomerReferrer(requestParameters: InvoicePrototypeFindByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeFindByIdCustomerReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async invoicePrototypeFindByIdCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeFindByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async invoicePrototypeFindByIdCustomerRoleMappings(requestParameters: InvoicePrototypeFindByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.invoicePrototypeFindByIdCustomerRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roles.
     */
    async invoicePrototypeFindByIdCustomerRolesRaw(requestParameters: InvoicePrototypeFindByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeFindByIdCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeFindByIdCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roles.
     */
    async invoicePrototypeFindByIdCustomerRoles(requestParameters: InvoicePrototypeFindByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.invoicePrototypeFindByIdCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation business.
     */
    async invoicePrototypeGetBusinessRaw(requestParameters: InvoicePrototypeGetBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetBusiness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/business`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation business.
     */
    async invoicePrototypeGetBusiness(requestParameters: InvoicePrototypeGetBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.invoicePrototypeGetBusinessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async invoicePrototypeGetBusinessCourierSettingRaw(requestParameters: InvoicePrototypeGetBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetBusinessCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/business/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async invoicePrototypeGetBusinessCourierSetting(requestParameters: InvoicePrototypeGetBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.invoicePrototypeGetBusinessCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierPackage.
     */
    async invoicePrototypeGetCourierPackageRaw(requestParameters: InvoicePrototypeGetCourierPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCourierPackage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierPackage.
     */
    async invoicePrototypeGetCourierPackage(requestParameters: InvoicePrototypeGetCourierPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.invoicePrototypeGetCourierPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async invoicePrototypeGetCourierPackageCourierRaw(requestParameters: InvoicePrototypeGetCourierPackageCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCourierPackageCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async invoicePrototypeGetCourierPackageCourier(requestParameters: InvoicePrototypeGetCourierPackageCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.invoicePrototypeGetCourierPackageCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async invoicePrototypeGetCourierPackageInvoiceRaw(requestParameters: InvoicePrototypeGetCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async invoicePrototypeGetCourierPackageInvoice(requestParameters: InvoicePrototypeGetCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeGetCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async invoicePrototypeGetCourierPackageOwnerRaw(requestParameters: InvoicePrototypeGetCourierPackageOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCourierPackageOwner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/owner`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async invoicePrototypeGetCourierPackageOwner(requestParameters: InvoicePrototypeGetCourierPackageOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeGetCourierPackageOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation customer.
     */
    async invoicePrototypeGetCustomerRaw(requestParameters: InvoicePrototypeGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation customer.
     */
    async invoicePrototypeGetCustomer(requestParameters: InvoicePrototypeGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeGetCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async invoicePrototypeGetCustomerAccessTokensRaw(requestParameters: InvoicePrototypeGetCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccessToken>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessTokenFromJSON));
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async invoicePrototypeGetCustomerAccessTokens(requestParameters: InvoicePrototypeGetCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccessToken>> {
        const response = await this.invoicePrototypeGetCustomerAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async invoicePrototypeGetCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeGetCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async invoicePrototypeGetCustomerCourierPackages(requestParameters: InvoicePrototypeGetCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.invoicePrototypeGetCustomerCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries invoices of CourierUser.
     */
    async invoicePrototypeGetCustomerInvoicesRaw(requestParameters: InvoicePrototypeGetCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Queries invoices of CourierUser.
     */
    async invoicePrototypeGetCustomerInvoices(requestParameters: InvoicePrototypeGetCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.invoicePrototypeGetCustomerInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries referrer of CourierUser.
     */
    async invoicePrototypeGetCustomerReferrerRaw(requestParameters: InvoicePrototypeGetCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierUser>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierUserFromJSON));
    }

    /**
     * Queries referrer of CourierUser.
     */
    async invoicePrototypeGetCustomerReferrer(requestParameters: InvoicePrototypeGetCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierUser>> {
        const response = await this.invoicePrototypeGetCustomerReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async invoicePrototypeGetCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeGetCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleMappingFromJSON));
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async invoicePrototypeGetCustomerRoleMappings(requestParameters: InvoicePrototypeGetCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleMapping>> {
        const response = await this.invoicePrototypeGetCustomerRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roles of CourierUser.
     */
    async invoicePrototypeGetCustomerRolesRaw(requestParameters: InvoicePrototypeGetCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * Queries roles of CourierUser.
     */
    async invoicePrototypeGetCustomerRoles(requestParameters: InvoicePrototypeGetCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.invoicePrototypeGetCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation deliveryRequest.
     */
    async invoicePrototypeGetDeliveryRequestRaw(requestParameters: InvoicePrototypeGetDeliveryRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetDeliveryRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/deliveryRequest`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation deliveryRequest.
     */
    async invoicePrototypeGetDeliveryRequest(requestParameters: InvoicePrototypeGetDeliveryRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.invoicePrototypeGetDeliveryRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async invoicePrototypeGetDeliveryRequestCourierRaw(requestParameters: InvoicePrototypeGetDeliveryRequestCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetDeliveryRequestCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/deliveryRequest/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async invoicePrototypeGetDeliveryRequestCourier(requestParameters: InvoicePrototypeGetDeliveryRequestCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.invoicePrototypeGetDeliveryRequestCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async invoicePrototypeGetDeliveryRequestCourierUserRaw(requestParameters: InvoicePrototypeGetDeliveryRequestCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetDeliveryRequestCourierUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/deliveryRequest/courierUser`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async invoicePrototypeGetDeliveryRequestCourierUser(requestParameters: InvoicePrototypeGetDeliveryRequestCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeGetDeliveryRequestCourierUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation deliveryLocation.
     */
    async invoicePrototypeGetDeliveryRequestDeliveryLocationRaw(requestParameters: InvoicePrototypeGetDeliveryRequestDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Town>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeGetDeliveryRequestDeliveryLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/deliveryRequest/deliveryLocation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TownFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation deliveryLocation.
     */
    async invoicePrototypeGetDeliveryRequestDeliveryLocation(requestParameters: InvoicePrototypeGetDeliveryRequestDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Town> {
        const response = await this.invoicePrototypeGetDeliveryRequestDeliveryLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a related item by id for roles.
     */
    async invoicePrototypeLinkCustomerRolesRaw(requestParameters: InvoicePrototypeLinkCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeLinkCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeLinkCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Add a related item by id for roles.
     */
    async invoicePrototypeLinkCustomerRoles(requestParameters: InvoicePrototypeLinkCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.invoicePrototypeLinkCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async invoicePrototypePatchAttributesRaw(requestParameters: InvoicePrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async invoicePrototypePatchAttributes(requestParameters: InvoicePrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async invoicePrototypeUnlinkCustomerRolesRaw(requestParameters: InvoicePrototypeUnlinkCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUnlinkCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUnlinkCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async invoicePrototypeUnlinkCustomerRoles(requestParameters: InvoicePrototypeUnlinkCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePrototypeUnlinkCustomerRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Update courierSetting of this model.
     */
    async invoicePrototypeUpdateBusinessCourierSettingRaw(requestParameters: InvoicePrototypeUpdateBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateBusinessCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/business/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async invoicePrototypeUpdateBusinessCourierSetting(requestParameters: InvoicePrototypeUpdateBusinessCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.invoicePrototypeUpdateBusinessCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async invoicePrototypeUpdateByIdCustomerAccessTokensRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async invoicePrototypeUpdateByIdCustomerAccessTokens(requestParameters: InvoicePrototypeUpdateByIdCustomerAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.invoicePrototypeUpdateByIdCustomerAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async invoicePrototypeUpdateByIdCustomerCourierPackagesRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async invoicePrototypeUpdateByIdCustomerCourierPackages(requestParameters: InvoicePrototypeUpdateByIdCustomerCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.invoicePrototypeUpdateByIdCustomerCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for invoices.
     */
    async invoicePrototypeUpdateByIdCustomerInvoicesRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for invoices.
     */
    async invoicePrototypeUpdateByIdCustomerInvoices(requestParameters: InvoicePrototypeUpdateByIdCustomerInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeUpdateByIdCustomerInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for referrer.
     */
    async invoicePrototypeUpdateByIdCustomerReferrerRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for referrer.
     */
    async invoicePrototypeUpdateByIdCustomerReferrer(requestParameters: InvoicePrototypeUpdateByIdCustomerReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.invoicePrototypeUpdateByIdCustomerReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async invoicePrototypeUpdateByIdCustomerRoleMappingsRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async invoicePrototypeUpdateByIdCustomerRoleMappings(requestParameters: InvoicePrototypeUpdateByIdCustomerRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.invoicePrototypeUpdateByIdCustomerRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roles.
     */
    async invoicePrototypeUpdateByIdCustomerRolesRaw(requestParameters: InvoicePrototypeUpdateByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateByIdCustomerRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling invoicePrototypeUpdateByIdCustomerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/customer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roles.
     */
    async invoicePrototypeUpdateByIdCustomerRoles(requestParameters: InvoicePrototypeUpdateByIdCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.invoicePrototypeUpdateByIdCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update invoice of this model.
     */
    async invoicePrototypeUpdateCourierPackageInvoiceRaw(requestParameters: InvoicePrototypeUpdateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePrototypeUpdateCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update invoice of this model.
     */
    async invoicePrototypeUpdateCourierPackageInvoice(requestParameters: InvoicePrototypeUpdateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePrototypeUpdateCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceRegenerateAllInvoicesForCourierRaw(requestParameters: InvoiceRegenerateAllInvoicesForCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['courierRegenerateMarketingInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'courierRegenerateMarketingInfoRequest',
                'Required parameter "courierRegenerateMarketingInfoRequest" was null or undefined when calling invoiceRegenerateAllInvoicesForCourier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/regenerateAllInvoicesForCourier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierRegenerateMarketingInfoRequestToJSON(requestParameters['courierRegenerateMarketingInfoRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invoiceRegenerateAllInvoicesForCourier(requestParameters: InvoiceRegenerateAllInvoicesForCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoiceRegenerateAllInvoicesForCourierRaw(requestParameters, initOverrides);
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async invoiceReplaceByIdPostInvoicesidReplaceRaw(requestParameters: InvoiceReplaceByIdPostInvoicesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceReplaceByIdPostInvoicesidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async invoiceReplaceByIdPostInvoicesidReplace(requestParameters: InvoiceReplaceByIdPostInvoicesidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceReplaceByIdPostInvoicesidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async invoiceReplaceByIdPutInvoicesidRaw(requestParameters: InvoiceReplaceByIdPutInvoicesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceReplaceByIdPutInvoicesid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async invoiceReplaceByIdPutInvoicesid(requestParameters: InvoiceReplaceByIdPutInvoicesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceReplaceByIdPutInvoicesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async invoiceReplaceOrCreatePostInvoicesReplaceOrCreateRaw(requestParameters: InvoiceReplaceOrCreatePostInvoicesReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async invoiceReplaceOrCreatePostInvoicesReplaceOrCreate(requestParameters: InvoiceReplaceOrCreatePostInvoicesReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceReplaceOrCreatePostInvoicesReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async invoiceReplaceOrCreatePutInvoicesRaw(requestParameters: InvoiceReplaceOrCreatePutInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async invoiceReplaceOrCreatePutInvoices(requestParameters: InvoiceReplaceOrCreatePutInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceReplaceOrCreatePutInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async invoiceUpdateAllRaw(requestParameters: InvoiceUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async invoiceUpdateAll(requestParameters: InvoiceUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.invoiceUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async invoiceUpsertWithWhereRaw(requestParameters: InvoiceUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async invoiceUpsertWithWhere(requestParameters: InvoiceUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search customers for invoice creation
     */
    async invoiceSearchCustomersRaw(requestParameters: InvoiceSearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceSearchCustomersResult>>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoiceSearchCustomers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/search-customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search customers for invoice creation
     */
    async invoiceSearchCustomers(requestParameters: InvoiceSearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceSearchCustomersResult>> {
        const response = await this.invoiceSearchCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search packages for invoice linking
     */
    async invoiceSearchPackagesForInvoiceRaw(requestParameters: InvoiceSearchPackagesForInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceSearchPackagesResult>>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoiceSearchPackagesForInvoice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        if (requestParameters['customerId'] != null) {
            queryParameters['customerId'] = requestParameters['customerId'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/search-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search packages for invoice linking
     */
    async invoiceSearchPackagesForInvoice(requestParameters: InvoiceSearchPackagesForInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceSearchPackagesResult>> {
        const response = await this.invoiceSearchPackagesForInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a custom invoice
     */
    async invoiceCreateCustomInvoiceRaw(requestParameters: InvoiceCreateCustomInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        // Either customerId or recipientName must be present; the backend
        // enforces this, so we do not hard-require customerId here (walk-ins).
        if (requestParameters['businessId'] == null) {
            throw new runtime.RequiredError(
                'businessId',
                'Required parameter "businessId" was null or undefined when calling invoiceCreateCustomInvoice().'
            );
        }

        if (requestParameters['items'] == null) {
            throw new runtime.RequiredError(
                'items',
                'Required parameter "items" was null or undefined when calling invoiceCreateCustomInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/create-custom`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Create a custom invoice
     */
    async invoiceCreateCustomInvoice(requestParameters: InvoiceCreateCustomInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceCreateCustomInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert a quote into an invoice
     */
    async invoiceConvertQuoteToInvoiceRaw(requestParameters: InvoiceConvertQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling invoiceConvertQuoteToInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/convert-quote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Convert a quote into an invoice
     */
    async invoiceConvertQuoteToInvoice(requestParameters: InvoiceConvertQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceConvertQuoteToInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview invoice for multiple packages without saving
     */
    async invoicePreviewMultiPackageRaw(requestParameters: InvoicePreviewMultiPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['packageIds'] == null) {
            throw new runtime.RequiredError(
                'packageIds',
                'Required parameter "packageIds" was null or undefined when calling invoicePreviewMultiPackage().'
            );
        }

        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoicePreviewMultiPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/preview-multi-package`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Preview invoice for multiple packages without saving
     */
    async invoicePreviewMultiPackage(requestParameters: InvoicePreviewMultiPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoicePreviewMultiPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create invoice for multiple packages
     */
    async invoiceCreateMultiPackageRaw(requestParameters: InvoiceCreateMultiPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['packageIds'] == null) {
            throw new runtime.RequiredError(
                'packageIds',
                'Required parameter "packageIds" was null or undefined when calling invoiceCreateMultiPackage().'
            );
        }

        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoiceCreateMultiPackage().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling invoiceCreateMultiPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Invoices/create-multi-package`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Create invoice for multiple packages
     */
    async invoiceCreateMultiPackage(requestParameters: InvoiceCreateMultiPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.invoiceCreateMultiPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get packages eligible for invoicing (Ready/Out for Delivery without paid invoices)
     */
    async invoiceGetEligiblePackagesRaw(requestParameters: InvoiceGetEligiblePackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage[]>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling invoiceGetEligiblePackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        if (requestParameters['customerId'] != null) {
            queryParameters['customerId'] = requestParameters['customerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Invoices/eligible-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Get packages eligible for invoicing (Ready/Out for Delivery without paid invoices)
     */
    async invoiceGetEligiblePackages(requestParameters: InvoiceGetEligiblePackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage[]> {
        const response = await this.invoiceGetEligiblePackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
